import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Prices from "./pages/Prices";
import Tickets from "./pages/Tickets";
import Orders from "./pages/Orders";
import ProtectedRoute from "./components/ProtectedRoute";
import OrderStation from "./pages/OrderStation";
import Markets from "./pages/Markets";
import SettlementManager from "./pages/SettlementManager";
import SettlementCalendar from "./pages/SettlementCalendar";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/settlement-calendar" 
          element={<SettlementCalendar />}
           />


        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
        />
                <Route
          path="/markets"
          element={
            <ProtectedRoute>
              <Markets />
            </ProtectedRoute>
          }
        />

        <Route
          path="/prices"
          element={
            <ProtectedRoute>
              <Prices />
            </ProtectedRoute>
          }
        />

        <Route
          path="/tickets"
          element={
            <ProtectedRoute>
              <Tickets />
            </ProtectedRoute>
          }
        />
        <Route
  path="/settlements"
  element={
    <ProtectedRoute>
      <SettlementManager />
    </ProtectedRoute>
  }
/>
        
        <Route
  path="/orders"
  element={
    <ProtectedRoute>
      <Orders />
    </ProtectedRoute>
  }
/>

<Route
  path="/station"
  element={
    <ProtectedRoute>
      <OrderStation />
    </ProtectedRoute>
  }
/>
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;
